import React from "react";
import { useDispatch } from "react-redux";
import { editProject } from "../../../features/filter/filterSlice";
function Project({ project }) {
  const dispatch = useDispatch();

  function handleChange() {
    dispatch(editProject({ ...project, isChecked: !project.isChecked }));
  }
  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        className={`${project?.colorClass}`}
        defaultChecked={true}
        checked={project.isChecked}
        onChange={handleChange}
      />
      <p className="label">{project?.projectName}</p>
    </div>
  );
}

export default Project;
